import React from "react";
import { Link } from "react-router-dom";
const contact_img = "/images/owp-modoc-BL316.png";

const ContactUs = () => {
  return (
    <section className="my-8 text-primary w-full">
      <h1 className="text-2xl md:text-3xl font-bold md:ml-8">Contact</h1>
      <div className="w-full bg-white my-6 rounded-xl h-fit overflow-hidden">
        <div className="flex flex-col xl:flex-row">
          <div className="break-words px-4 md:px-8 py-6 lg:w-[40%]">
            <h2 className="font-bold text-lg">OWP</h2>
            <div className="text-gray-700 text-md my-4">
              <h2>Office of Water Programs</h2>
              <h2>3020 State University Drive</h2>
              <h2>Modoc Hall Suite 1001</h2>
              <h2>Sacramento, CA 95819</h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <h2>
                <a href="tel:9162784483">916.278.4483</a>
              </h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <h2>
                <a href="mailto:pfas@owp.csus.edu">pfas@owp.csus.edu</a>
              </h2>
            </div>
            <br />
            <h2 className="font-bold text-lg">
              State Water Resources Control Board
            </h2>
            <div className="text-gray-700 text-md my-4">
              <h2>Division of Drinking Water</h2>
              <h2>1001 J St</h2>
              <h2>24th Floor</h2>
              <h2>Sacramento, CA 95814</h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <h2>
                <a href="tel:9164495577">916.449.5577</a>
              </h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <Link
                to="https://www.waterboards.ca.gov/drinking_water/programs"
                target="_blank"
                className="underline"
              >
                <h2>www.waterboards.ca.gov/drinking_water/programs</h2>
              </Link>
            </div>
          </div>
          <div className="xl:w-[60%] flex-grow">
            <img
              src={contact_img}
              alt="Contact Us"
              className="rounded-b-xl lg:rounded-r-xl lg:rounded-b-none h-full aspect-video object-cover object-right w-full md:w-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
  return (
    <section className="my-8 text-primary w-full">
      <h1 className="text-3xl md:text-4xl font-bold md:ml-8">Contact</h1>
      <div className="w-full bg-white my-6 rounded-xl h-fit overflow-hidden">
        <div className="flex flex-col xl:flex-row">
          <div className="break-words px-4 md:px-8 py-6 lg:w-[40%]">
            <h2 className="font-bold text-lg">OWP</h2>
            <div className="text-gray-700 text-md my-4">
              <h2>Office of Water Programs</h2>
              <h2>3020 State University Drive</h2>
              <h2>Modoc Hall Suite 1001</h2>
              <h2>Sacramento, CA 95819</h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <h2>
                <a href="tel:9162784483">916.278.4483</a>
              </h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <h2>
                <a href="mailto:pfas@owp.csus.edu">pfas@owp.csus.edu</a>
              </h2>
            </div>
            <br />
            <h2 className="font-bold text-lg">
              State Water Resources Control Board
            </h2>
            <div className="text-gray-700 text-md my-4">
              <h2>Division of Drinking Water</h2>
              <h2>1001 J St</h2>
              <h2>24th Floor</h2>
              <h2>Sacramento, CA 95814</h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <h2>
                <a href="tel:9164495577">916.449.5577</a>
              </h2>
            </div>
            <div className="text-secondary hover:text-accent text-md my-1">
              <a
                href="https://www.waterboards.ca.gov/drinking_water/programs"
                target="_blank"
                className="underline"
              >
                <h2>www.waterboards.ca.gov/drinking_water/programs</h2>
              </a>
            </div>
          </div>
          <div className="xl:w-[60%] flex-grow">
            <img
              src={contact_img}
              alt="Contact Us"
              className="rounded-b-xl lg:rounded-r-xl lg:rounded-b-none h-full aspect-video object-cover object-right w-full md:w-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
